// extracted by mini-css-extract-plugin
export default {"arrow":"carousel_arrow__AQ2l9","left":"carousel_left__2NXkl","right":"carousel_right__LxTDz","item":"carousel_item__KJVHG"};